export default () => ({
    categorias: []
})